export default {"src":"/evde-internet/_next/static/media/red-calendar.2a385cbe.svg","height":32,"width":32};